// import and load the media(audio) file
import shutterSoundMP3 from 'audio/shutter.mp3'
export const shutterSound: HTMLAudioElement = new Audio(shutterSoundMP3)
